import { Component, OnInit, OnDestroy } from '@angular/core';
import { DeviceService } from '../../../services/device.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as L from 'leaflet';
import { NgApexchartsModule } from 'ng-apexcharts';
//import { ApexAxisChartSeries, ApexOptions } from 'ng-apexcharts';
import ApexCharts from 'apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { PeriodTypeEnum } from '../../../enums/period-type-enum';
import {
  GoogleMap,
  MapMarkerClusterer,
  MapAdvancedMarker,
  MapMarker,
} from '@angular/google-maps';
@Component({
  selector: 'app-device-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgApexchartsModule,
    BsDatepickerModule,
    RouterModule,
    GoogleMap,
    MapMarkerClusterer,
    MapAdvancedMarker,
    MapMarker,
  ],
  templateUrl: './device-details.component.html',
  styleUrl: './device-details.component.css',
})
export class DeviceDetailsComponent {
  fromDate: Date | null = null;
  toDate: Date | null = null;
  chartFromDate: Date | null = null;
  chartToDate: Date | null = null;
  minDate: Date | null = null;

  currentDate: Date = new Date();

  time_zone: String = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Math = Math;
  chartFilter: any = {
    device_id: '',
    period: '',
    start_date: '',
    end_date: '',
  };
  private markers: google.maps.Marker[] = [];
  datePickerConfig: Partial<BsDatepickerConfig>;
  chartDatePicheConfig: Partial<BsDatepickerConfig>;
  constructor(
    public deviceService: DeviceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) {
    const today = new Date();
    // this.currentDate = today.toISOString().split('T')[0];
    this.datePickerConfig = {
      dateInputFormat: 'DD/MM/YYYY',
    };
    this.chartDatePicheConfig = {
      dateInputFormat: 'DD/MM/YYYY',
    };
  }

  private devUiInput$ = new Subject<string>();
  devUiValue: string = '';
  deviceInfo: any;
  // fromDate: string = '';
  // toDate: string = '';
  usageCount: any;
  map!: google.maps.Map;
  devEui: string = '';
  formattedModifiedDate: string = '';
  commissionDate: string = '';
  chart: any;
  devUIValid: boolean = false;
  today: string = new Date().toISOString().split('T')[0];
  //currentDate: string;
  deviceSuggestions: any[] = [];

  chartSeries: ApexAxisChartSeries = [];
  /*chartOptions: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '10%',
      },
    },
    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: (value) => `${value} Cubic Meter`,
      },
    },
  };*/
  modifiedDate: string = '';

  usageInfo: any;
  deviceId: string = '';

  ngOnInit(): void {
    //this.devEui = this.deviceService.getDeviceEUI();
    this.devEui = this.route.snapshot.paramMap.get('dev_eui') ?? '';
    if (this.devEui != '') {
      this.getDeviceDetails(this.devEui);
    }
    const savedDevUI = localStorage.getItem('selectedDevUI');
    if (savedDevUI) {
      this.getDeviceDetails(savedDevUI);
    }
    this.showMap();
    this.devUiInput$
      .pipe(
        filter((value: string) => value.length >= 3),
        switchMap((devUi: string) =>
          this.deviceService.getMatchingDevices(devUi)
        )
      )
      .subscribe((response: any) => {
        this.deviceSuggestions = response.data.devices;
      });
  }

  onDevUiInput(event: any): void {
    this.devUiValue = event.target.value.trim();
    if (this.devUiValue.length === 0) {
      this.deviceSuggestions = [];
    } else {
      this.devUiInput$.next(this.devUiValue);
    }
  }

  onTextChange(event: any): void {
    this.devUIValid = false;
  }

  selectDevice(devEui: string): void {
    this.devUiValue = devEui;
    this.deviceSuggestions = [];
    this.getDeviceDetails(this.devUiValue);
  }

  getDeviceDetails(devUI: string) {
    devUI = devUI.trim();
    if (devUI) {
      this.devUIValid = false;
      this.deviceService.getDeviceDetails(devUI).subscribe(
        (response) => {
          localStorage.setItem('selectedDevUI', devUI);
          this.deviceInfo = response.data.deviceInfo;
          if (this.deviceInfo.modified_on) {
            const modifiedDate = new Date(this.deviceInfo.modified_on);
            this.formattedModifiedDate = modifiedDate
              .toLocaleDateString('en-GB')
              .replace(/\//g, '-');
          }
          if (this.deviceInfo.commission_date) {
            const commissionDate = new Date(this.deviceInfo.commission_date);
            this.commissionDate = commissionDate
              .toLocaleDateString('en-GB')
              .replace(/\//g, '-');
          }

          let latitude = this.deviceInfo.location.latitude;
          let longitude = this.deviceInfo.location.longitude;
          this.deviceId = response.data.deviceInfo.id;
          this.showMap(latitude, longitude);
          //this.showBarGraph(this.deviceId);
          this.chartFilter.device_id = this.deviceId;
          this.showConsumptionChart();
          this.getPreviousMonthAndDayUsage(this.deviceId);
          // this.resetDateFilter();
          console.log(this.deviceInfo);
        },
        (error) => {
          this.toastr.error(error.error.message, 'Device Details');
          console.log(error.error.message);
        }
      );
    } else {
      this.devUIValid = true;
    }
  }

  preventInput(event: KeyboardEvent): void {
    event.preventDefault();
  }

  onToDateChange(date: Date): void {
    this.toDate = date;
    this.getUsageCount(this.deviceId);
  }

  getUsageCount(deviceId: string) {
    if (this.fromDate && this.toDate && deviceId) {
      let filter = {
        device_id: deviceId,
        start_date: moment(this.fromDate).format('YYYY-MM-DD'),
        end_date: moment(this.toDate).format('YYYY-MM-DD'),
      };

      this.deviceService.getUsageData(filter).subscribe(
        (response) => {
          this.usageCount = response.data;
          if (response.data) {
            this.usageCount = response.data;
          } else {
            this.usageCount = '';
          }
        },
        (error) => {
          console.log(error.error);
        }
      );
    }
  }

  getPreviousMonthAndDayUsage(deviceId: string) {
    let offsetMinutes = new Date().getTimezoneOffset();

    let filter = {
      device_id: deviceId,
      timezone_offset: offsetMinutes,
    };
    this.deviceService.getDailyAndMonthlyWaterConsumption(filter).subscribe(
      (response) => {
        this.usageInfo = response.data;
      },
      (error) => {
        console.log(error.error);
      }
    );
  }

  // Assuming you have already loaded the Google Maps JavaScript API
  showMap(latitude?: number | string, longitude?: number | string) {
    const defaultLat = 0;
    const defaultLng = 0;
    const mapOptions = {
      center: { lat: defaultLat, lng: defaultLng },
      zoom: 2,
    };

    const mapElement = document.getElementById('map');

    // Check if the map element exists
    if (!mapElement) {
      console.error('Map element not found!');
      return;
    }

    // Initialize map if not already done
    if (!this.map) {
      this.map = new google.maps.Map(mapElement, mapOptions);
    }

    // Clear existing markers
    this.clearMarkers();

    // If latitude and longitude are provided, create a marker
    if (latitude !== undefined && longitude !== undefined) {
      const lat = Number(latitude);
      const lng = Number(longitude);

      // Center and zoom the map to the marker's position
      this.map.setCenter(new google.maps.LatLng(lat, lng));
      this.map.setZoom(13);

      // Create the marker with the custom icon
      const markerIcon = {
        url: '../../../assets/images/map-marker-red.svg',
        scaledSize: new google.maps.Size(30, 30),
      };

      const marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        icon: markerIcon,
      });

      this.markers.push(marker);
    }
  }

  // Method to clear markers
  clearMarkers() {
    this.markers.forEach((marker) => marker.setMap(null));
    this.markers = [];
  }

  showConsumptionChart() {
    this.deviceService.getWaterConsumptionChartData(this.chartFilter).subscribe(
      (response: any) => {
        const consumptionData = response.data;
        if (consumptionData && consumptionData.length) {
          let datas = consumptionData.map((x: any) => x.last_consumption);
          let categories = consumptionData.map((x: any) => x.date);
          this.populateChart(datas, categories);
        }
      },
      (error: any) => {
        this.toastr.error(error.error.message.Text, 'Device Details');
        this.spinner.hide();
        console.error(error.error.message);
      }
    );
  }

  downloadDeviceAlerts(deviceId: string, dev_eui: string) {
    this.spinner.show();

    this.deviceService
      .exportDeviceAlerts({ device_id: deviceId, time_zone: this.time_zone })
      .subscribe(
        (data: Blob) => {
          const blob = new Blob([data], {
            //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            type: 'application/octet-stream',
          });
          saveAs(
            blob,
            `Alerts_${dev_eui}_${moment().format('DDMMYYYYHHmmss')}.xlsx`
          );
          this.toastr.success(
            'Alerts downloaded successfully',
            'Device Details'
          );
          this.spinner.hide();
        },
        (error) => {
          console.error('Error downloading the file', error);
          this.toastr.error('There are no alerts', `Device Details`);
          this.spinner.hide();
        }
      );
  }

  populateChart(datas: (number | null | string)[], categories: string[]) {
    // Convert string numbers to actual numbers, preserving null values
    const processedData = datas.map((value) =>
      value === null ? null : Number(value)
    );

    const validDataPoints = processedData.filter(
      (value) => value !== null
    ).length;

    const options = {
      series: [
        {
          name: 'Total Consumption',
          data: processedData,
        },
      ],
      chart: {
        height: 400,
        type: validDataPoints > 1 ? 'line' : 'scatter', // Use scatter chart if only one point
        zoom: {
          enabled: false,
        },
      },
      colors: ['#6c82bb'], // Set the line color here
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: validDataPoints > 1,
        curve: 'straight',
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // Alternating row colors
          opacity: 0.5,
        },
      },
      markers: {
        size: 5, // Set the size of the markers (dots)
        colors: ['#6c82bb'], // Marker colors
        strokeColors: '#fff', // Outline color of markers
        strokeWidth: 2, // Outline width
        hover: {
          size: 7, // Marker size on hover
        },
      },
      xaxis: {
        categories: categories,
        tickAmount: categories.length - 1, // Ensure all categories are shown
      },
      yaxis: {
        min: 0, // Ensure the y-axis starts at 0
        floating: false, // Ensure y-axis includes all data points
        labels: {
          formatter: (value: any) => `${value} Cubic Meter`,
        },
      },
      legend: {
        position: 'bottom', // Places the legend at the bottom
        horizontalAlign: 'center', // Centers the legend horizontally
        showForSingleSeries: true, // Ensures the legend is displayed for a single series
      },
      tooltip: {
        theme: 'light', // Use the light theme for better customization
        style: {
          fontSize: '11px',
          fontFamily: 'Arial, sans-serif',
        },
        custom: function ({
          series,
          seriesIndex,
          dataPointIndex,
          w,
        }: {
          series: number[][];
          seriesIndex: number;
          dataPointIndex: number;
          w: any;
        }) {
          // Get the y-axis value for the current data point
          const value = series[seriesIndex][dataPointIndex];

          // If the value is null, return null to disable the tooltip
          if (value === null) {
            return null;
          }

          // Otherwise, return the tooltip content
          return `
            <div style="background-color: #8393bb; padding: 8px; border-radius: 4px; color: white;">
              <strong>${w.globals.seriesNames[seriesIndex]}: ${value}</strong>
            </div>`;
        },
      },
    };

    // Render the chart
    if (this.chart) {
      this.chart.destroy(); // Destroy the previous chart if it exists
    }
    this.chart = new ApexCharts(document.querySelector('#chart'), options);
    this.chart.render();
  }

  onPeriodChange() {
    this.chartFromDate = null;
    this.chartToDate = null;
    this.chartFilter.start_date = '';
    this.chartFilter.end_date = '';
    switch (this.chartFilter.period) {
      case 'Daily':
        this.chartDatePicheConfig = {
          dateInputFormat: 'DD/MM/YYYY',
          showWeekNumbers: false,
          displayMonths: 1,
          selectFromOtherMonth: true,
          selectWeek: false,
        };
        this.chartToDate = new Date();
        break;
      case 'Monthly':
        this.chartDatePicheConfig = {
          dateInputFormat: 'MMM YYYY',
          minMode: 'month',
        };
        this.minDate = null;
        this.currentDate = new Date();
        break;
      case 'Yearly':
        this.chartDatePicheConfig = {
          dateInputFormat: 'YYYY',
          minMode: 'year',
        };
        this.minDate = null;
        this.currentDate = new Date();
        break;

      default:
        this.minDate = null;
        this.currentDate = new Date();
        this.showConsumptionChart();
        break;
    }
  }

  onStartChartDatePickerChange(date: Date) {
    if (date) {
      switch (this.chartFilter.period) {
        case PeriodTypeEnum.Daily:
          this.chartFilter.start_date = moment(date).format('YYYY-MM-DD');
          // Calculate the exact date two months ago
          const twoMonthsLater = new Date(date); // Start with the selected date
          twoMonthsLater.setMonth(date.getMonth() + 2);
          if (twoMonthsLater > this.currentDate) {
            let today: Date = new Date();
            if (twoMonthsLater < today) {
              this.currentDate = twoMonthsLater;
            } else {
              this.currentDate = today;
            }
          } else {
            this.currentDate = twoMonthsLater;
          }

          break;
        case PeriodTypeEnum.Monthly:
          this.chartFilter.start_date = moment(date).format('MMM YYYY');
          break;
        case PeriodTypeEnum.Yearly:
          this.chartFilter.start_date = moment(date).format('YYYY');
          break;

        default:
          this.chartFilter.start_date = '';
          break;
      }
      if (this.chartFilter.start_date && this.chartFilter.end_date) {
        this.showConsumptionChart();
      }
    }
  }

  onEndChartDatePickerChange(date: Date) {
    if (date) {
      switch (this.chartFilter.period) {
        case PeriodTypeEnum.Daily:
          this.chartFilter.end_date = moment(date).format('YYYY-MM-DD');
          // Calculate the exact date two months ago
          const twoMonthsAgo = new Date(date); // Start with the selected date
          twoMonthsAgo.setMonth(date.getMonth() - 2);

          // Handle month rollover for cases like March -> January
          if (twoMonthsAgo.getDate() !== date.getDate()) {
            twoMonthsAgo.setDate(0); // Set to last day of the previous month
          }
          this.minDate = twoMonthsAgo;
          break;
        case PeriodTypeEnum.Monthly:
          this.chartFilter.end_date = moment(date).format('MMM YYYY');
          break;
        case PeriodTypeEnum.Yearly:
          this.chartFilter.end_date = moment(date).format('YYYY');
          break;

        default:
          this.chartFilter.end_date = '';
          break;
      }
      if (this.chartFilter.start_date && this.chartFilter.end_date) {
        this.showConsumptionChart();
      }
    }
  }

  exportCustomDateWaterConsumption(consumer_id: any): void {
    let filter = {
      device_id: this.deviceId,
      consumer_id: consumer_id,
      start_date: moment(this.fromDate).format('YYYY-MM-DD'),
      end_date: moment(this.toDate).format('YYYY-MM-DD'),
    };
    this.deviceService.exportCustomDateWaterConsumption(filter).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], {
          //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          type: 'application/octet-stream',
        });
        saveAs(blob, `Consumptions_${moment().format('DDMMYYYYHHmmss')}.xlsx`);
        this.toastr.success(
          'Consuption details exported successfully',
          'Device Details'
        );
        this.spinner.hide();
      },
      (error) => {
        console.error('Error downloading the file', error);
        this.toastr.error('There are no consuptions', `Device Details`);
        this.spinner.hide();
      }
    );
  }

  ngOnDestroy(): void {
    this.deviceService.removeDeviceEUI();
    localStorage.removeItem('selectedDevUI');
  }
}
